import { Alert } from '@pocketlaw/tetris';
export function BasicAlert(props) {
    const { message } = props;
    return <Alert appearance="danger" message={message}/>;
}
